import React from 'react';
import { Autocomplete, TextField } from 'components/mui';
import { CustomerOption } from 'api/cases/searchCustomers';

interface CustomerFilterProps {
  value: CustomerOption | null;
  options: CustomerOption[];
  onChange: (_e: unknown, val: CustomerOption | null) => void;
  onInputChange: (_e: unknown, val: string) => void;
  onOpen: () => void;
}

function CustomerFilter({ value, options, onChange, onInputChange, onOpen }: CustomerFilterProps) {
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(opt) => opt.Name || ''}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      isOptionEqualToValue={(opt, val) => opt.Id === val.Id}
      onOpen={onOpen}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Filter by Customer"
          size="small"
          placeholder="All customers"
        />
      )}
    />
  );
}

export default CustomerFilter;
